import {
    genericError, codeSuccess, codeFailure, authorizationError, invalidNumber
  } from '../../constants/messages';
  import {setLoading, setAlertModal } from './app';
  import axiosInstance from '../../utilities/interceptorUtilities';
  import {setActivePolicy} from './policies';

export const SET_OPERATOR = 'SET_OPERATOR';
export const GET_OPERATORS = 'GET_OPERATORS';
export const SET_POLICY_VERIFIED = 'SET_VERIFIED';

export const verifyPolicy = () => {
  return async(dispatch, getState) => {
    try {
      dispatch({type: SET_POLICY_VERIFIED, verified: false});//clear previous verification
        let isAgent = false;
        let requestData;
        let policyNumber = getState().policies.activePolicy.PolicyNumber;
        dispatch(setLoading(true));
        if(getState().user.agentAuthenticated) {//is agent
          isAgent = true;
          const aysUserInfo = getState().user.agentInfo;
          requestData = {
              PolicyNumber: policyNumber,
              AgentCode: aysUserInfo.agentCode,
              UserId : aysUserInfo.userId,
              isAgent: isAgent
              };
        } else {//is employee
          const aysUserInfo = getState().user.agentInfo;
          requestData = {
            PolicyNumber: policyNumber,
            UserId: aysUserInfo.userId,
            isAgent: isAgent,
          };
        }
        const body = JSON.stringify(requestData);
        const url = process.env.REACT_APP_API_URL + `/api/DriveRight/VerifyPolicyMLM2?isAgent=${isAgent}`;
        const response = await axiosInstance.post(url, body, {
          headers: { 'content-type': 'application/json' },
          withCredentials: true,
        });

      const verified = response.data;
       if (!verified) {
        dispatch(setActivePolicy(null));
        dispatch(setAlertModal(true, 'error', authorizationError));
          setTimeout(() => {
            dispatch(setAlertModal(false, ''));
          }, 5000);
       }
       dispatch(setLoading(false));
       dispatch({type: SET_POLICY_VERIFIED, verified});
      } catch(err) {
        dispatch(setLoading(false));
        dispatch(setAlertModal(true, 'error', genericError));
          setTimeout(() => {
            dispatch(setAlertModal(false, ''));
          }, 5000);
      }
  }
};

export const getOperators = (policyNumber) => {
    return async (dispatch, getState) => {
      try {
        dispatch(setLoading(true));
        let requestData;
        let isAgent;
        if (!getState().user.agentInfo) {//is customer care user
          isAgent = false;
          const userInfo = getState().user.userInfo;
          requestData = {
              PolicyNumber: policyNumber,
              AccountId: userInfo.AccountId,
              UserId: userInfo.UserId,
              isAgent: isAgent,
              SessionId: userInfo.sessionId,
              EmailId: userInfo.UserEmailId
            };
        } else if(getState().user.agentAuthenticated) {//is agent
          isAgent = true;
          const aysUserInfo = getState().user.agentInfo;
          requestData = {
              PolicyNumber: policyNumber,
              AgentCode: aysUserInfo.agentCode,
              UserId : aysUserInfo.userId,
              isAgent: isAgent
              };
        } else {//is employee
          isAgent = false;
          const aysUserInfo = getState().user.agentInfo;
          requestData = {
            PolicyNumber: policyNumber,
            UserId: aysUserInfo.userId,
            isAgent: isAgent,
          };
        }
        const body = JSON.stringify(requestData);
        const url = process.env.REACT_APP_API_URL + `/api/DriveRight/GetOperators?isAgent=${isAgent}`;
        const response = await axiosInstance.post(url, body, {
          headers: { 'content-type': 'application/json' },
          withCredentials: true,
        });

        const operators = response.data;
         if (operators) {
          let filteredOperators = operators.filter(operator => operator.TelematicsInd);
          dispatch({type: GET_OPERATORS, operators: filteredOperators})
         }
        
        dispatch(setLoading(false));

      } catch(err) {
        dispatch(setLoading(false));
        dispatch(setAlertModal(true, 'error', genericError));
          setTimeout(() => {
            dispatch(setAlertModal(false, ''));
          }, 5000);
      }
    }
};

export const setOperator = (operator) => {
  return (dispatch) => {
      try {
        dispatch({ type: SET_OPERATOR, operator });
      } catch (err) {
        dispatch(setAlertModal(true, 'error', genericError));
        setTimeout(() => {
          dispatch(setAlertModal(false, ''));
        }, 5000);
      }
    };
};

export const sendCode = newDevice => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let isAgent = getState().user.agentAuthenticated ? true : false;
      const operator = getState().driveright.operator;

      if (operator.ArityId) {
        const url = process.env.REACT_APP_API_URL + `/api/DriveRight/SendCode?newDevice=${newDevice}&isAgent=${isAgent}`;
        let userId;
        if (getState().user.agentInfo) {
          userId = getState().user.agentInfo.userId;
        } else {
          userId = getState().user.userInfo.UserId;
        }
        const body = JSON.stringify({
          HostDevicePhoneNumber: operator.Cellphone,
          id: operator.Id,
          ArityId: operator.ArityId,
          DeviceID: operator.DeviceId,
          PolicyNumber: getState().policies.activePolicy.PolicyNumber,
          UserId: userId,
          AgentCode: getState().user.agentInfo?.agentCode
        });
        const response = await axiosInstance.post(url, body, {
            headers: { 'content-type': 'application/json' },
            withCredentials: true,
        });
          if (response.data === "Success") {
            dispatch(setAlertModal(true, '', codeSuccess));
          } else {
            dispatch(setAlertModal(true, 'error', response.data));
          }
      } else {
        dispatch(setAlertModal(true, 'error', invalidNumber));
      }
        dispatch(setLoading(false));
        setTimeout(() => {dispatch(setAlertModal(false, ""))}, 5000);
    } catch(err) {
      dispatch(setAlertModal(true, 'error', codeFailure));
      setTimeout(() => {dispatch(setAlertModal(false, ""))}, 5000);
      dispatch(setLoading(false));
    }
  } 
};